import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { LOGIN } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { setSanctumToken } from '~/helpers/sanctumAuth';
import {
  LoginRequest,
  LoginResponse,
} from '~/types/api';
import { MutationError } from '~/types/form';
import { LoginRequestSchema, LoginResponseSchema } from '~/validation/api/loginResponse';

export const postLogin = async (obj: LoginRequest) => {
  const body = LoginRequestSchema.parse(obj);

  try {
    const response = await axios.post(LOGIN, body);

    const json = response.data;

    const data = LoginResponseSchema.parse(json);

    setSanctumToken(data.token);

    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export function useMutateLogin() {
  return useMutation<LoginResponse, MutationError, LoginRequest>({
    mutationFn: (obj: LoginRequest) => {
      return postLogin(obj);
    },
  });
}
